import { IContactCustom } from '@/src/ContactsModule/interfaces/CustomFieldsInterfaces';

interface ContactData {
  [key: string]: string;
}

const extractContactData = (fields: IContactCustom): ContactData => {
  const data: ContactData = {};

  for (const field of fields.contactCustomFields) {
    data[field.name] = field.value || '';
  }

  return data;
};

export default extractContactData;
